import { useEffect, useState } from 'react'
import { Dialog } from '@headlessui/react'
import Table from 'components/__new/common/Table'
import { ReactComponent as IconBack } from "assets/images/icons/project-icons/arrow_back.svg"
import { ReactComponent as IconInfo } from "assets/images/icons/project-icons/info-icon-red.svg"
import { ReactComponent as IconTimes } from "assets/images/icons/project-icons/times.svg"
import CurrencyFormat from 'utils/currencyFormat'
import SquareDropdown from 'utils/SquareDropdown'
import { useSelector, useDispatch } from 'react-redux'
import CsvEntryEditModal from './CsvEntryEditModal'
import FormDrawer from 'components/__new/common/form-drawer'
import Maybe from 'components/__new/common/Maybe'
import { toast } from 'react-toastify'
import { getProviders } from 'store/entities/billPayment/action'


const BulkCableReviewModal = ({
    isOpen,
    toggleBulkCableReview, 
    togglePurchaseModal,
    initiatePurchase,
    generateClientReference,
    defaultParams
    }) => {
        
    const dispatch = useDispatch();
    // const [batch, setBatch] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [totalAmount, setTotalAmount] = useState("");
    
    const { cableCsvData, providers } = useSelector((s) => s.entities.billPayment);
    const [parsedData, setParsedData] = useState([]);
    const [errorItems, setErrorItems] = useState([]);
    const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
    const [entryToDelete, setEntryToDelete] = useState(null);
    
    const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen);
    
    // const toggleSingleItem = (id) => {
    //     const alreadyExists = batch?.indexOf(id) > -1
    //     if (alreadyExists) {
    //         const filtered = batch?.filter(item => item !== id)
    //         setBatch(filtered)
    //     } else {
    //         setBatch([...batch, id])
    //     }
    // }
    
    const editEntry = (item) => {
        setSelectedItem(item);
        toggleEditModal();
    }
    
    const deleteEntry = () => {
        const filteredEntries = parsedData?.filter((item) => item?.id !== entryToDelete?.id)
        
        setParsedData(filteredEntries)
    }
    
    const updateCsvEntry = (entry) => {
        const editedEntries = parsedData?.map((item) => item?.id === entry?.id ? {...entry} : item)
        
        setParsedData(editedEntries)
    }
    
    const closeReviewModal = () => {
        toggleBulkCableReview();
        togglePurchaseModal();
    }
    
    const submitBulkItems = () => {
        
        const invalidMinAmount = parsedData?.find((item) => item?.amount < 50)
        
        if(invalidMinAmount) {
            toast.error("Each recipient must have a minimum amount of ₦50")
        } else {
            const params = {
                ...defaultParams,
                beneficiaries: parsedData.map((item) => {
                    return {
                        service: item.service,
                        clientReference: generateClientReference(item.phone),
                        phone: item.phone,
                        amount: parseInt(item.amount) * 100,
                    }
                }),
            }
            
            toggleBulkCableReview();
            initiatePurchase(params)
        }
    }
    
    useEffect(() => {
        if(cableCsvData !== null && cableCsvData?.length > 0) {
            setParsedData(cableCsvData);
        }
    }, [cableCsvData])
    
    useEffect(() => {
        if(parsedData?.length > 0) {
            const totalBulkAmount = parsedData.reduce((acc, cur) => acc + Number(cur?.amount), 0);

            setTotalAmount(totalBulkAmount);
        }
        
        const formattedResult = parsedData?.map((entry, index) => {
                if(entry?.phone?.length !== 10 || !entry?.service?.length || !entry?.amount?.length) {
                    return {
                        ...entry,
                        id: index + 1,
                        isInvalid: true
                    }
                } else {
                    return {
                        ...entry,
                        id: index + 1,
                        isInvalid: false,
                    }
                }
            })
            
        const invalidItems = formattedResult?.filter((record) => record?.isInvalid === true)
        setErrorItems(invalidItems)
        
        // dispatch(saveAirtimeCsvErrors(invalidItems))
        // eslint-disable-next-line
    }, [parsedData])
    
    useEffect(() => {
        dispatch(getProviders());
        // eslint-disable-next-line
    }, []);
    
    return (
        <>
            <ConfirmDeletionModal
                isOpen={isConfirmDeleteOpen}
                setIsOpen={setIsConfirmDeleteOpen}
                onProceed={() => {
                    setIsConfirmDeleteOpen(false);
                    deleteEntry();
                }}
            />
            
            <CsvEntryEditModal 
                isOpen={isEditModalOpen}
                providers={providers?.response?.cableTv}
                selectedItem={selectedItem}
                setIsOpen={setIsEditModalOpen}
                updateCsvEntry={updateCsvEntry}
            />
            
            <Dialog open={isOpen} onClose={() => {}} className="relative z-50">
                <div className={`fixed inset-0 bg-black/40`} aria-hidden="true" />
                <div className="fixed inset-0 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center py-8">
                        <Dialog.Panel className="w-full mx-auto max-w-[80%] bg-white rounded-xl shadow-xl max-h-[600px] overflow-y-scroll">
                            <div className='p-7'>
                                <div className='flex items-center'>
                                    <div className="w-7 h-7 flex items-center justify-center mr-3 bg-[#f4f4f4] rounded-md">
                                        <IconBack
                                            className='cursor-pointer'
                                            onClick={closeReviewModal}
                                        />
                                    </div>
                                    <div className="font-semibold lg:text-lg">Review CSV</div>
                                </div>
                                
                                
                                <Maybe condition={errorItems?.length > 0}>
                                    <div className="w-full flex items-center justify-between rounded-md bg-[#fef2f2] my-7 px-4 py-2">
                                        <div className="flex items-center">
                                            <IconInfo />
                                            
                                            <div className="text-[#dc2626] ml-2 text-sm">
                                                {errorItems?.length} Error(s) Detected
                                            </div>
                                            
                                            <div>
                                                &nbsp;- {errorItems?.length} out of {parsedData?.length} entries contain some errors
                                            </div>
                                        </div>
                                    </div>
                                </Maybe>
                                
                                <div className="flex items-center justify-between w-full my-7">
                                    <div className='font-medium'>
                                        {parsedData?.length} Cable TV {parsedData?.length > 1 ? "Entries" : "Entry"}
                                    </div>
                                    
                                    <div>
                                        <span className="text-gray-500">Total Amount:&nbsp;</span>
                                        <span className="font-medium">{CurrencyFormat(totalAmount)}</span>
                                    </div>
                                </div>
                                
                                <div>
                                    <Table>
                                        <Table.Head>
                                            {/* <th></th> */}
                                            <th>Smartcard Number</th>
                                            <th>Biller</th>
                                            <th>Bundle</th>
                                            <th>Amount</th>
                                            <th></th>
                                        </Table.Head>
                                        <Table.Body>
                                            {parsedData?.map((item) => {
                                                const smartCardError = item?.phone?.length !== 10
                                                const billerError = !item?.biller?.length
                                                const bundleError = !item?.bundle?.length
                                                const amountError = !item?.amount?.length
                                                
                                                return (
                                                    <tr key={item?.id}>
                                                        {/* <td style={{ width: '10px' }}>
                                                            <input
                                                                type="checkbox"
                                                                value={item?.id}
                                                                checked={batch?.includes(item?.id)}
                                                                onChange={() => toggleSingleItem(item?.id)}
                                                                className="form-checkbox w-5 h-5 multi-select"
                                                            />
                                                        </td> */}
                                                        <td style={{ backgroundColor: smartCardError ? "#fef2f2" : "" }}>
                                                            <div className="capitalize text-[#667085]">
                                                                {item?.smartCardNumber}
                                                            </div>
                                                        </td>
                                                        <td style={{ backgroundColor: billerError ? "#fef2f2" : "" }}>
                                                            <div className="text-[#667085] capitalize">
                                                                {item?.biller}
                                                            </div>
                                                        </td>
                                                        <td style={{ backgroundColor: bundleError ? "#fef2f2" : "" }}>
                                                            <p className="text-gray-700">
                                                                {item?.bundle}
                                                            </p>
                                                        </td>
                                                        <td style={{ backgroundColor: amountError ? "#fef2f2" : "" }}>
                                                            <p className="text-gray-700">
                                                                {CurrencyFormat(item?.amount)}
                                                            </p>
                                                        </td>
                                                        <td className='relative'>
                                                            <div className="lefts-36">
                                                                <SquareDropdown
                                                                    menu={[
                                                                        {
                                                                            type: "div",
                                                                            text: "Edit",
                                                                            click: () => editEntry(item)
                                                                        },
                                                                        {
                                                                            type: "div",
                                                                            text: <span className='text-ep-red-500'>Remove</span>,
                                                                            click: () => {
                                                                                setEntryToDelete(item);
                                                                                setIsConfirmDeleteOpen(true);
                                                                            }
                                                                        },
                                                                    ]}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            )}

                                        </Table.Body>
                                    </Table>
                                </div>
                                
                                <div className="border-t w-full flex items-center justify-end mt-7 pt-5">
                                    <button type="button" onClick={closeReviewModal} className="btn btn-transparent-primary mr-3">
                                        Cancel
                                    </button>
                                    
                                    <button onClick={submitBulkItems} disabled={errorItems?.length > 0} type="button" className="btn btn-ep-primary">
                                        Purchase
                                    </button>
                                </div>
                            </div>
                        </Dialog.Panel>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

const ConfirmDeletionModal = ({isOpen, setIsOpen, onProceed}) => {

return (
    <FormDrawer display="center" size="sm" isOpen={isOpen} setIsOpen={() => {}}>
        <div className="p-7 pb-4">
            <div className='pb-2 mb-2'>
                <div className="flex items-center justify-between">
                    <div className="font-bold">
                        Remove This Entry
                    </div>
                    
                    <div onClick={() => setIsOpen(false)} className='w-5 h-5 bg-[#f4f4f4] cursor-pointer rounded-md flex items-center justify-center'>
                        <IconTimes width={10} />
                    </div>
                </div>
                
                
                <div className="my-5 text-ep-gray-600">
                    Are you sure you want to perform this action?
                </div>
                
                
                <div className="w-full flex items-center justify-center">
                    <button onClick={onProceed} className="btn bg-[#DC2626] text-white w-2/4">
                        Yes
                    </button>
                    
                    <button onClick={() => setIsOpen(false)} className="btn btn-transparent-primary w-2/4 ml-3">
                        No
                    </button>
                </div>
            </div>
        </div>
    </FormDrawer>
    )
}

export default BulkCableReviewModal